/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 251228
*/
'use strict';

import {
    getTableRows
} from './ctssHtml.js';

import {
    getPromise,
    savePromise
} from './ctssJQuery.js';
import {
    getAM_PM_DDL_Async,
    getHoursDDL_Async
} from './ctssTimeSpans.js'
import {
    isDataModified,
    setModified
} from './ctssVal.js';
import {
    appDebugMode,
    getAppToken,
    setMenu
} from './snSite.js';

const token = getAppToken();

const getContactsDataAsync = async () => {
    const contactMsgTime = new Date(2020, 0, 1, 8).toUTCString(); /* Hours is 0-23 so 9:00 AM default is 8 */
    return await getPromise({ url: `Contacts/${token.CG}/Data/5/${contactMsgTime}` }) /* 5 = FeatureID for CCards */
}
const getContactName = (key) =>
    contacts[contacts.findIndex(x => x.id === parseInt(key, 10))].member;

const getContactNoDataRow = () =>
    '<tr><td colspan="4">No contacts have been entered...</td></tr>';

const getContactRow = (params = {}) => {
    const {
        id,
        member,
        contactByNotifMsg,
        contactByEmail
    } = params.data;
    let row = `<tr id="${id}">` +
        `<td class="col-md-8">${member}</td>` +
        `<td class="col-md-1" style="text-align: center;"><input id="cbByNotifMsg_${id}" type="checkbox" class="k-checkbox" `;
    if (contactByNotifMsg) {
        row += ' checked';
    }
    row += `><label class="k-checkbox-label" for="cbByNotifMsg_${id}"></td>` +
        `<td class="col-md-1" style="text-align: center;"><input id="cbByEmail_${id}" type="checkbox" class="k-checkbox" `;
    if (contactByEmail) {
        row += ' checked';
    }
    row += `><label class="k-checkbox-label" for="cbByEmail_${id}"></td>` +
        `<td class="col-md-2 text-right">` +
        `<span class="fa fa-trash mRight5" title="Delete contact..." data-toggle="modal" data-target="#deleteDlg" data-key="${id}"></span>` +
        `</tr>`;
    return row;
}

const initAddDlgAsync = async () => {
    if (members.length === 0) {

        try {
            members = await snMembers.getMembersDDLAsync();

            for (let i = 0; i < members.length; i++) { // Remove existing contact members
                if (contacts.findIndex(x => x.memberID === parseInt(members[i].value, 10)) > -1) {
                    members.splice(i, 1);
                }
            }

        }
        catch (error) { }

        $('#editContact').kendoAutoComplete({
            dataSource: members.map((x) => x.text),
            placeholder: 'Select contact...'
        })
    }
    $('#btnDlgAddContact').off('click').click(async () => {
        const isContactByEmail = $('#cbContactByEmail').is(':checked');
        const isContactByNotifMsg = $('#cbContactByNotifMsg').is(':checked')
        if (!isContactByEmail && !isContactByNotifMsg) {
            $('#divAddDlgErrMsg')
                .text('Please check contact by email, push notfication, or both.')
                .removeClass('hidden');
            return;
        }
        const name = $('#editContact').val();
        if (name.length === 0) {
            $('#divAddDlgErrMsg')
                .text('Please enter a contact.')
                .removeClass('hidden');
            return;
        }
        const idxMember = members.findIndex(x => x.text === name);
        const idxContact = contacts.findIndex(x => x.member === name);
        if (idxContact > -1) {
            $('#divAddDlgErrMsg')
                .text(name + ' is already a contact.')
                .removeClass('hidden');
            return;
        }
        else if (idxMember === -1) {
            $('#divAddDlgErrMsg')
                .text(name + ' is not a registered church member...')
                .removeClass('hidden');
            return;
        } else {
            $('#addDlg').modal('hide');
        }
        await saveContactAsync({
            id: -1,
            memberID: members[idxMember].value,
            contactByEmail: isContactByEmail,
            contactByNotifMsg: isContactByNotifMsg
        })
        .then(async () => {
            $('#addDlg').modal('hide');
            try {
                const data = await getContactsDataAsync();
                refreshContacts(data);
            }
            catch (error) { }
        });
        return;
    });
}

const initDeleteDlg = () => {
    $('#deleteDlg').on('show.bs.modal', (e) => {
        const key = e.relatedTarget.dataset.key;
        $('#deletePrompt').text(`Are you sure you want to delete the ${getContactName(key)} as a contact?`);
        $('#btnDelete').off('click').click(async () => {
            await deletePromise({
                url: 'Contacts',
                data: { cg: token.CG, id: key },
                divErrMsg: 'divDelDlgErrMsg'
            })
                .then(() => {
                    $('#deleteDlg').modal('hide');
                    /* Just removing from page is faster than going to server to refresh */

                    contacts.splice(contacts.findIndex(x => x.id === parseInt(key, 10)), 1);
                    $('#' + key).remove();
                });
        });
    });
}

const refreshContacts = (data) => {
    if (data) {
        contactsScheduleID = data.id;
        contacts = data.contacts;
        let hrs = new Date(data.contactMsgTime).getHours();
        if (hrs > 11) {
            $('#ddlAM_PM').val("1");
            hrs -= 12;
        }
        $('#ddlHours').val(hrs.toString());
    }
    getTableRows({ arr: contacts, fnGetRow: getContactRow, fnNoDataRow: getContactNoDataRow, gridNm: 'gridContacts' });
    $('#loader').css('display', 'none');
    setModified(false);
}

const saveContactAsync = async (params) => {
    const contact = {
        id: params.id,
        cg: token.CG,
        featureID: 5,
        contactByEmail: params.contactByEmail,
        contactByNotifMsg: params.contactByNotifMsg
    }
    if (params.memberID !== undefined) {
        contact.memberID = params.memberID;
    }
    await savePromise({
        url: 'Contacts',
        data: contact,
        divErrMsg: 'divUpdDlgErrMsg'
    });
}
const saveScheduleAsync = async () => {
    let hr = parseInt($('#ddlHours').val(), 10);
    if ($('#ddlAM_PM').val() === "1") {
        hr += 12;
    }
    const contactMsgSchedule = {
        id: contactsScheduleID,
        cg: token.CG,
        featureID: 5,
        contactMsgTime: new Date(2020, 0, 1, hr)
    }
    await savePromise({
        url: 'Contacts/ScheduleMsg',
        data: contactMsgSchedule
    })
        .then(() => setModified(false));
}

/* public variables and functions */

let contacts = [];
let contactsScheduleID = -1;
let members = [];

const initAsync = async () => {
    document.getElementById("loader").style.display = "none";
    window.onbeforeunload = () => {
        if (isDataModified() === true) {
            return "Your changes have not been saved...";
        }
    };
    setMenu();

    $('input,select').on('change', () => setModified(true));

    getAM_PM_DDL_Async();
    getHoursDDL_Async({ dflt: '8' });

    try {
        const data = await getContactsDataAsync();
        refreshContacts(data);
    }
    catch (error) { }

    await initAddDlgAsync();

    $('#gridContacts>tbody input:checkbox').off('click').click(async function () {
        const contactID = this.id.substring(this.id.indexOf('_') + 1);
        await saveContactAsync({
            id: parseInt(contactID, 10),
            contactByEmail: $(`#cbByEmail_${contactID}`).is(':checked'),
            contactByNotifMsg: $(`#cbByNotifMsg_${contactID}`).is(':checked')
        });
    });

    initDeleteDlg();

    $('#ddlHours,#ddlAM_PM').on('change', async () => {
        await saveScheduleAsync();
    });
};

window.snCCardNotifications = {
    initAsync
};